<template>
  <div>
    <CDropdownDivider v-if="showDivider" />
    <div class="p-2">
      <CRow>
        <CCol>
          <CBadge class="mb-1" :color="bid.bidType == 'FIRM' ? 'info' : 'secondary'"><div style="font-size: 120%;">Lot {{bid.offer.getLot()}}</div></CBadge>
        </CCol>
        <CCol>
          <div class="nowrap float-right">
            <strong>{{ bid.quantity }}</strong>mt @ <strong>${{ bid.price }}</strong> /mt
          </div>
        </CCol>
      </CRow>
      <CRow>
        <CCol class="pt-2 pb-1">
          <strong class="mb-0">{{ bid.offer.grainLabel }}</strong>
          <span v-if="bid.offer.grade"> | {{ bid.offer.gradeLabel }}</span>
        </CCol>
        <CCol col=2>
          <div class="float-right" style="position: relative; top: -8px;">
            <CBadge class="ml-2 mt-2" :color="'warning'" v-if="bid.offer.isComplete">Traded</CBadge>
            <CBadge class="ml-2 mt-2" :color="'success'" v-else>{{ bid.offer.quantityRemainingLabel }} remaining</CBadge>
          </div>
        </CCol>
      </CRow>
      <CRow>
        <CCol class="pt-1 pb-1">
          <CLink><CIcon  name="cil-location-pin"/></CLink> {{ bid.shortLocatedLabel }}
        </CCol>
      </CRow>


      <CRow class="mt-2">
        <CCol sm=12 md=6 class="pl-2 pb-0">
          <ul class="pl-4 mb-0">
            <li>{{ bid.offer.seasonLabel }}</li>
            <li>Sold {{ bid.dateSoldDateOnlyFormatted }}</li>
          </ul>
        </CCol>
      </CRow>

    </div>
  </div>
</template>

<script>
import Bid from '@/model/bid'

export default {
  name: 'SoldCard',
  props: {
    bid: Bid,
    showDivider: {
      type: Boolean,
      default: true
    }
  }
}
</script>
